module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/f183922e3ee0beddc89bf9e6b31030f3.svg";